import React from 'react'

function CatSket() {
    return (
        <div className="space-y-2 flex flex-col items-center">
            <div className="w-32 h-32 rounded-full bg-gray-100 animate-pulse" />
            <div className="w-24 h-3 rounded-full bg-gray-100 animate-pulse" />
            <div className="w-14 h-3 rounded-full bg-gray-100 animate-pulse" />
        </div>
    )
}

export default CatSket